module.exports = {"audiences":["alphaMembers"],"experimentVersion":"v1","experimentAllocation":{"alphaMembers":1},"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/superHomeReactions.json
// module id = t892
// module chunks = 1